import {Injectable} from '@angular/core';
import {environment} from 'src/environments/environment';
import {HttpClient} from "@angular/common/http";
import {map, Observable} from "rxjs";
import {FeatureType} from 'src/app/interfaces/product';
import {castToHttpParams} from 'src/app/utilities/types';

@Injectable({
  providedIn: 'root'
})
export class ProductService {
  baseUrl: string;

  constructor(
    private http: HttpClient
  ) {
    this.baseUrl = `${environment.apiEndPoint}/Product`;
  }

  getCategoryProducts(categoryId: number,
                      topNumber: number,
                      IgnorePagination: boolean = true, showLoader:boolean = false,paginated= false,currentPageNumber?:any): Observable<object> {


    let endPoint2 = '/CategoryProduct/GetCategoriesParentAndChildProductsNew/';
    let url: string = `${this.baseUrl}${endPoint2}`
    url += paginated ? '?paginated=true' : '';
    if(url.includes('?')) {
      url += 'showLoader='+showLoader
    } else {
      url += '?showLoader='+showLoader
    }
    let data = {
      categoryId: Number(categoryId),

      CurrentPage: currentPageNumber??1,
      ProductStatus: 0,
      IgnorePagination: false,
      PageSize: 50,
    }


    return this.http.get(`${url}`, {params: castToHttpParams(data)});

  }

  getCategoriesProducts(categoriesId: number[], topNumbers: number[])
    : Observable<object> {
    let url: string = `${this.baseUrl}/CategoryProduct/GetCategoryProductsByCategories`;


    url += "?";
    for (let categoryId of categoriesId) {
      url += "categoriesId=" + categoryId + "&";
    }
    for (let topNumber of topNumbers) {
      url += "topNumbers=" + topNumber + "&";
    }
    return this.http.get(`${url}`);
  }

  getProductDetails(id: number, channelId: any,platformId:any='0', isMobile:any='0'): Observable<object> {
    return this.http.get(`${this.baseUrl}/Product/ProductDetailsNew/${id}/${channelId}/${platformId}/${isMobile}`);
  }

  getSizeGuidDetails(id: number): Observable<object> {
    return this.http.get(`${this.baseUrl}/Attribute/GetAttributeById/${id}`);
  }

  getProducts(id: number): Observable<object> {
    return this.http.get(`${this.baseUrl}/Product/GetProductById/productId=${id}`);
  }

  GetAllProductsByFeatureNew(FeatureType: number, topNumber: number, order: number): Observable<any> {
    return this.http.get(
      `${this.baseUrl}/Product/GetAllProductsByFeatureNew`,
      {params: {FeatureType, TopNumber: topNumber}}
    ).pipe(map((product: any) => {
      return {data: product, order};
    }));
  }

  GetAllProductsByFeature(enumValue: FeatureType, topNumber: number, paginated: boolean = false,currentPageNumber?:any, showLoader: boolean=false, channel:any = null): Observable<object> {
    let url: string = `${this.baseUrl}/Product/GetAllProductsByFeatureNew`;

    let data:any = {
      showLoader: showLoader,
      paginated: paginated,
      FeatureType: enumValue,
      CurrentPage: currentPageNumber,
      ProductStatus: 0,
      IgnorePagination: false,
      PageSize: topNumber,
    }

    // if it's worldwide products (dpay)
    if(channel && channel == "2") { 
      data.isWorldWide = true;
    }

    return this.http.get(`${url}`,{params:castToHttpParams(data)});
  }

  FilterWithProductName(name: any,currentPage?:any,pageSize?:any): Observable<any> {
    return this.http.get(`${this.baseUrl}/Product/SearchProducts?paginated=true&SearchString=${name}&currentPage=${currentPage}&pageSize=${pageSize}`);

  }

  GetProductsByShop(shopId: number): Observable<object> {
    return this.http.get(`${this.baseUrl}/Product/GetProductsByShop/${shopId}`);
  }

  verifyImageURL(url: string, baseUrl: string): string {
    if(url && (url.includes('http://') || url.includes('https://'))) {
      return url;
    }
    if (url) {
      if (url.startsWith('/')) url = url.substring(1);
      const sub = url.substring(0, url.indexOf("/"));
      if (sub.toLowerCase().includes("images")) return `${baseUrl}/${url}`;
      else {
        return `${baseUrl}/Images/${url}`;
      }
    } else {
      return '';
    }

  }


}
